// GLSL shader（由 .glsl 迁移为 TS 模块）
export default /* glsl */ `// ============================================================
// GSplat Center - 中心投影
// 对标 PlayCanvas gsplatCenter.js
// 使用 RTE (Relative-To-Eye) 技术解决大坐标精度问题
// ============================================================

uniform mat4 modelMatrix;
uniform mat4 viewMatrix;
uniform mat4 projectionMatrix;
uniform vec4 viewport_size;
uniform vec4 camera_params;

uniform vec3 cameraPositionHigh;
uniform vec3 cameraPositionLow;
uniform vec3 originToCameraHigh;
uniform vec3 originToCameraLow;

bool initCenter(vec3 inputCenter, inout SplatCenter center) {
  vec3 relativePos;

  #ifdef GSPLAT_WORKBUFFER_DATA
    vec3 originToCamera = originToCameraHigh + originToCameraLow;
    relativePos = inputCenter + originToCamera;
  #else
    vec4 worldPos = modelMatrix * vec4(inputCenter, 1.0);
    vec3 t1 = worldPos.xyz - cameraPositionHigh;
    relativePos = t1 - cameraPositionLow;
  #endif

  vec4 centerView = viewMatrix * vec4(relativePos, 0.0);
  centerView.w = 1.0;

  if (camera_params.w != 1.0 && centerView.z > 0.0) {
    return false;
  }

  vec4 centerProj = projectionMatrix * centerView;

  #ifdef WEBGPU
    centerProj.z = clamp(centerProj.z, 0.0, abs(centerProj.w));
  #else
    centerProj.z = clamp(centerProj.z, -abs(centerProj.w), abs(centerProj.w));
  #endif

  center.proj = centerProj;
  center.projMat00 = projectionMatrix[0][0];
  center.view = centerView.xyz;
  #ifdef GSPLAT_WORKBUFFER_DATA
    center.modelView = viewMatrix;
  #else
    center.modelView = viewMatrix * modelMatrix;
  #endif

  return true;
}

#ifndef GSPLAT_WORKBUFFER_DATA
bool initCenterFromWorld(vec3 worldCenter, inout SplatCenter center) {
  vec3 t1 = worldCenter - cameraPositionHigh;
  vec3 relativePos = t1 - cameraPositionLow;
  vec4 centerView = viewMatrix * vec4(relativePos, 0.0);
  centerView.w = 1.0;

  if (camera_params.w != 1.0 && centerView.z > 0.0) {
    return false;
  }

  vec4 centerProj = projectionMatrix * centerView;
  #ifdef WEBGPU
    centerProj.z = clamp(centerProj.z, 0.0, abs(centerProj.w));
  #else
    centerProj.z = clamp(centerProj.z, -abs(centerProj.w), abs(centerProj.w));
  #endif

  center.proj = centerProj;
  center.projMat00 = projectionMatrix[0][0];
  center.view = centerView.xyz;
  center.modelView = viewMatrix * modelMatrix;
  return true;
}
#endif
`
